export default __webpack_public_path__ + "static/media/seven_of_cups.8abe8685.png";